import { PaginationResponse } from "models/pagination-response";
import { ILicitacaoPagedRequest } from "models/request/licitacao-paged-request";
import { ILicitacaoPagedResponse } from "models/response/licitacao-paged-response";
import { IModalidadeLicitacaoResponse } from "models/response/modalidade-licitacao-response";
import { IFaseLicitacaoResponse } from "models/response/fase-licitacao-response";
import { ISituacaoLicitacaoResponse } from "models/response/situacao-licitacao-response";
import { IOrgaoResponse } from "models/response/orgao-response";

export type LicitacoesState = {
    licitacoes: PaginationResponse<ILicitacaoPagedResponse>;
    licitacoesPagedRequest: ILicitacaoPagedRequest;
    orgaos: IOrgaoResponse[];
    modalidades: IModalidadeLicitacaoResponse[];
    fases: IFaseLicitacaoResponse[];
    situacoes: ISituacaoLicitacaoResponse[];
    ultimaAtualizacao: string | null;
    loading: boolean;
    error: string | null;
};

export enum ACTION_TYPES {
    setLicitacoes = 'setLicitacoes',
    setLicitacoesPagedRequest = 'setLicitacoesPagedRequest',
    setOrgaos = 'setOrgaos',
    setModalidades = 'setModalidades',
    setFases = 'setFases',
    setSituacoes = 'setSituacoes',
    setUltimaAtualizacao = 'setUltimaAtualizacao',
    setLoading = 'setLoading',
    setError = 'setError',
}

export const LicitacoesReducer = (state: LicitacoesState, action: any): LicitacoesState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.setLicitacoesPagedRequest:
            return { ...state, licitacoesPagedRequest: payload };
        case ACTION_TYPES.setLicitacoes:
            return { ...state, licitacoes: payload };
        case ACTION_TYPES.setOrgaos:
            return { ...state, orgaos: payload };
        case ACTION_TYPES.setModalidades:
            return { ...state, modalidades: payload };
        case ACTION_TYPES.setFases:
            return { ...state, fases: payload };
        case ACTION_TYPES.setSituacoes:
            return { ...state, situacoes: payload };
        case ACTION_TYPES.setUltimaAtualizacao:
            return { ...state, ultimaAtualizacao: payload };
        case ACTION_TYPES.setLoading:
            return { ...state, loading: payload };
        case ACTION_TYPES.setError:
            return { ...state, error: payload };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
}
